import { jsx as _jsx } from "react/jsx-runtime";
import { tailwindMerge } from "@air/tailwind-variants";
import { memo } from "react";
import FileExtensionPreview from "~/components/FileExtensionPreview";
export const AssetGalleryCardProcessing = /*#__PURE__*/ memo((param)=>{
    let { className, ext } = param;
    return /*#__PURE__*/ _jsx("div", {
        className: tailwindMerge("shimmer-background relative flex flex-1 flex-col items-center justify-center bg-grey-4", className),
        children: /*#__PURE__*/ _jsx(FileExtensionPreview, {
            ext: ext,
            text: "Processing",
            color: "gray",
            size: "medium",
            className: "grow justify-center"
        })
    });
});
AssetGalleryCardProcessing.displayName = "AssetGalleryCardProcessing";
